import { Box, Stack, Typography } from '@mui/material'
import type { SurveyElement } from '../MidYearSummary'
import { SummaryElement } from './SummaryElement'

interface Props {
  element: SurveyElement
  answers: Record<string, any>
}
export const SummaryPanelDynamic = ({ element, answers }: Props): JSX.Element | null => {
  const panelAnswers: Array<Record<string, any>> = answers[element.name] ?? []

  if (panelAnswers.length === 0) return null

  return (
    <Stack gap={2}>
      {panelAnswers.map((panelData, index) => (
        <Box key={index}>
          <Typography variant='subtitle2' sx={{ mb: 1.5 }}>
            {element.title} ({index + 2})
          </Typography>
          <Stack gap={2}>
            {(element.templateElements ?? []).map((templateEl) => (
              <SummaryElement
                key={templateEl.name}
                element={templateEl}
                answers={panelData}
                isPanelDynamic={true}
              />
            ))}
          </Stack>
        </Box>
      ))}
    </Stack>
  )
}
